import { assign } from 'lodash'

const splitPrice = (item) => {
  if (!item.price) {
    return [null, null]
  }

  return item.price.toString().split('.')
}
export default (item) => {
  const agenda = assign({}, item)
  const price = splitPrice(agenda)

  agenda._parsed = {
    'price_real': price[0],
    'price_cents': price[1]
  }

  return agenda
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/resources/parse.js